import {ChildVaribles} from './child-varibles';

export class VariableTypes {
  public Name: string;
  public Children: ChildVaribles[];
  public ObjectType: string;
  public ContentName: string;
  public Length: number;
  public ContentType: string;
  public Dependency: string;
  public States: any[];
  public ValueDependency: string;
  public VariantType: string;
  public ValuePath: string;
  public DisplayPath: string;

  constructor(name: string) {
    this.Name = name;
  }
}
